import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';

import AppBar from './AppBar';
import SideNav from './SideNav';
import sideNavItems from '../../config/sideNavItems';

function DefaultLayout(props) {
  const { children } = props;
  const [open, setOpen] = React.useState(true);
  const toggleSideNav = () => {
    setOpen(!open);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar isSidebarOpen={open} toggleSideNav={toggleSideNav} />
      <SideNav
        open={open}
        toggleSideNav={toggleSideNav}
        sideNavItems={sideNavItems}
      />
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.greyLightest
              : theme.palette.grey[900],
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
        }}
      >
        <Toolbar />
        <Container maxWidth="lg" sx={{ my: 2 }}>
          {children}
        </Container>
      </Box>
    </Box>
  );
}

export default DefaultLayout;
